<template>
  <v-layout wrap>
    <Diccionario :id_unit="this.idUnidad"/>
    <HeaderFill :title="`Gramatica`" :router="`/unidad/detalle/${this.idUnidad}`"/>
    <v-flex text-xs-center xs12 mb-4>
      <img src="../../assets/images/gramatica/gramatica.svg">
    </v-flex>
    <v-flex xs12>
      <p class="white--text e-sub-sub-title w-75 mx-auto mb-4" >{{currentGrammar.descripcionFull}}</p>
    </v-flex>
    <v-flex xs12>
      <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
      <carousel 
        v-if="!loading"
        :responsive="carouselProperty" 
        :nav="false" 
        :dots="false" 
        :margin="10" 
        :center="true" class="e-carousel--unidad"
        >
        <CardLeccion
          v-for="lesson in loadedLessons"
          :key="lesson.id_lesson"
          :letra="lesson.name_lesson"
          :id_unit="`${lesson.id_unit}`"
          :id_grammar="`${lesson.id_grammar}`"
          :id_lesson="`${lesson.id_lesson}`"
          :descripcion="lesson.description"
        />
      </carousel>
    </v-flex>
  </v-layout>
</template>

<script>
import CardLeccion from '../../components/Gramatica/Leccion/CardLeccion'
import { storeFirebase } from "../../store/firebase";

export default {
  name: 'gramaticaDashboard',
  components: {
    CardLeccion
  },
  props: ['idUnidad','idGrammar'],
  data() {
    return {
      //gramatica: this.$route.params.cardGramatica,
      loading: true,
      carouselProperty: {
        '0': {
          items: 1,
          nav: false,
          loop: true,
          center: true
        },
        '768': {
          items: 3,
          nav: false,
          loop: true,
          center: true
        }
      },
      progressUser: {}
    }
  },
  created() {
    this.loadLessons()
  },
  computed: {
    loadedLessons () {
      const lessons = storeFirebase.getters.loadedLessons
      const unitVal = 'unit_' + this.idUnidad
      const progressGrammar = this.progressUser.grammar[unitVal]
      const gramVal = 'grammar_' + this.idGrammar
      let progressLesson = {
        lessonsIsFull: true
      }
      for(let index in progressGrammar) {
        const data = progressGrammar[index]
        for(let value in data){
          if(value === gramVal) {
            progressLesson = data
            break
          }
        }
      }
      if (!progressLesson.lessonsIsFull) {
        for (let index in lessons) {
          const data = lessons[index]
          const lessonVal = 'lesson_' + data.id_lesson
          progressLesson[lessonVal] = 0;
        }
        progressLesson['totalLesson'] = lessons.length
        progressLesson.lessonsIsFull = true
        this.updateUserProgress(this.progressUser)
      }
      return lessons
    },
    currentGrammar () {
      const grammars = storeFirebase.getters.loadedGrammar
      return grammars.find(grammar => grammar.id_gramatica == this.idGrammar)
    }
  },
  methods: {
    loadLessons () {
      const payload = {
        id_unit:  Number(this.idUnidad),
        id_grammar:  Number(this.idGrammar)
      }
      const idUnidad = Number(this.idUnidad)
      this.progressUser = storeFirebase.getters.userProgress
      storeFirebase.dispatch("loadGrammar", {id_unidad: idUnidad})
      storeFirebase.dispatch("loadLessons", payload).then(() => {
        setTimeout(() => {
          this.loading = false
        }, 2500)
      })
    },
    updateUserProgress(newUserProgress) {
      storeFirebase.dispatch('updateUserProgress', newUserProgress)
    }
  }
}
</script>
